module.exports = __webpack_public_path__ + "img/icon-darkness-fx.3cfb8594.svg";